// extracted by mini-css-extract-plugin
export default {"main":"MobileView_main__jciMw","main_two":"MobileView_main_two__dAeGr"};